import React from 'react';
import PropTypes from 'prop-types';
import Product from './Product';

const ProductsGrid = ({ title, subTitle, products }) => {
  return (
    <section className="ProductsGrid">
      <h2 className="col-xs-12 ProductGrid__Title ">{title}</h2>
      <div className="col-xs-12 ProductGrid__SubTitle">{subTitle}</div>
      {products.map((product, i) => (
        <Product key={i} {...product} />
      ))}
    </section>
  );
};

ProductsGrid.propTypes = {
  products: PropTypes.arrayOf(PropTypes.object),
  subTitle: PropTypes.string,
  title: PropTypes.string,
};

export default ProductsGrid;
